// extracted by mini-css-extract-plugin
module.exports =  {"noteWrapper":"noteWrapper___xauvY","noteContent":"noteContent___c1SRv"};